// extracted by mini-css-extract-plugin
export default {"container":"AdminChecklist_container__bEAM+","checklist":"AdminChecklist_checklist__8xMZ+","item":"AdminChecklist_item__ydBvs","itemIcon":"AdminChecklist_itemIcon__GyDRb"};